//
//
//
//
//
//
//
//
//
//
//
//
//

import InfoList from '@/components/InfoList';
import LanguageAdd from './LanguageAdd';
import PersonalCard from '~/components/Card/PersonalCard';
import { mapGetters, mapActions } from 'vuex';
import { languageLevels } from '@/utils/jobs';

export default {
  name: 'Language',
  components: { InfoList, LanguageAdd, PersonalCard },
  data() {
    return {
      languageLevels,
      dlgShow: false,
      editMode: false,
      currentItem: {},
      languageList: [],
    };
  },
  computed: {
    ...mapGetters('personal', ['resumeData']),
    dataForInfoList() {
      if (!this.languageList) return [];
      const list = this.languageList.map(item => {
        return {
          title: item.name,
          list: [
            { label: '聽：', contents: [this.getLanguageLv(item.listen)] },
            { label: '說：', contents: [this.getLanguageLv(item.speak)] },
            { label: '讀：', contents: [this.getLanguageLv(item.reading)] },
            { label: '寫：', contents: [this.getLanguageLv(item.writing)] },
          ],
        };
      });
      return list;
    },
  },
  methods: {
    ...mapActions('personal', ['setLanguageList']),
    getLanguageLv(value) {
      const currentItem = this.languageLevels.find(
        item => item.value === value,
      );
      return currentItem && currentItem.label;
    },
    handleDeleteLanguage(payload) {
      this.$api('userDeleteLanguage', payload).then(() => {
        this.$message.success('刪除成功!');
        this.getLanguageList();
      });
    },
    getLanguageList() {
      this.$api('userGetLanguageList').then(data => {
        this.languageList = data;
      });
    },
    openAdd() {
      this.currentItem = {};
      this.dlgShow = true;
      this.editMode = false;
    },
    openEdit(index) {
      this.currentItem = this.resumeData.userLanguageList[index];
      this.dlgShow = true;
      this.editMode = true;
    },
    onDelete(index) {
      this.$confirm('是否刪除此語言？', '提示', {
        type: 'warning',
      }).then(() => {
        const payload = {
          id: this.resumeData.userLanguageList[index].id,
        };
        this.handleDeleteLanguage(payload);
      });
    },
  },
  mounted() {
    this.getLanguageList();
  },
};
